import { MutationTree } from "vuex";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";
import { ForexHistoryItem } from "@/feature/Forex/api/history/forex-history.interface";
import { ForexApprovalState } from "@/feature/Forex/store/approval/interface";
import { ForexApprovalMutation } from "@/feature/Forex/store/approval/constants";
import { deleteApprovalItems } from "@/feature/Forex/store/approval/utils";
import { ForexToApproveCount, PaymentOrderCount } from "@/feature/Forex/api/approval/forex-approval.interface";

export default <MutationTree<ForexApprovalState>> {

	[ForexApprovalMutation.addList](state, list: ForexHistoryItem[]) {
		state.list.push(...list);
	},

	[ForexApprovalMutation.setNextPage](state) {
		state.pageNumber++;
	},

	[ForexApprovalMutation.resetPage](state) {
		state.pageNumber = 1;
		state.isEndPage = false;
		state.list = [];
	},

	[ForexApprovalMutation.resetFilter](state) {
		state.operationType = null;
	},

	[ForexApprovalMutation.setIsEndPage](state, isEndPage: boolean) {
		state.isEndPage = isEndPage;
	},

	[ForexApprovalMutation.setLoading](state, loading: boolean) {
		state.loadingCount += loading ? 1 : (state.loadingCount && -1);
	},

	[ForexApprovalMutation.deleteItems](state, ids: number[]) {
		deleteApprovalItems(state, ids);
	},

	[ForexApprovalMutation.setOperationType](state, payload: ForexOperationType | null) {
		state.operationType = payload;
	},

	[ForexApprovalMutation.setToApprovalCount](state, payload: ForexToApproveCount) {
		state.toApprovalCount = payload;
	},

	[ForexApprovalMutation.setPaymentOrderCount](state, payload: PaymentOrderCount) {
		state.paymentOrderCount = payload;
	},

}